var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "wrap",
      staticClass: "scale-wrap",
      on: { dblclick: _vm.onDblclick, dbltouch: _vm.onDblclick },
    },
    [
      _c(
        "div",
        {
          ref: "zoom",
          staticClass: "scale-content",
          on: { panzoomzoom: _vm.onZoom, panzoompan: _vm.onPan },
        },
        [
          _c("img", {
            attrs: { src: _vm.src, alt: _vm.alt },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }